import { useLocation } from "react-router-dom";
import { useChatContext } from "../../providers/ChatContext";
import { ChatFAB } from "./ChatFAB";
import { ChatPanel } from "./ChatPanel";

const WEBSITE_ROUTE_PREFIXES = ["/viajes", "/blog", "/cotizar", "/cotizar-exito"];

function isWebsiteRoute(pathname: string): boolean {
  if (pathname === "/") return true;
  return WEBSITE_ROUTE_PREFIXES.some((p) => pathname.startsWith(p));
}

export function ChatWidget() {
  const { isOpen, toggleChat, openChat, sessionId, startSession, language } = useChatContext();
  const location = useLocation();

  const handleFABPress = () => {
    if (!isOpen && !sessionId) {
      openChat();
      startSession(language);
      return;
    }
    toggleChat();
  };

  const onWebsite = isWebsiteRoute(location.pathname);

  return (
    <>
      <ChatPanel isOpen={isOpen} />
      {!onWebsite && <ChatFAB isOpen={isOpen} onPress={handleFABPress} />}
    </>
  );
}
